import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.sass'],
})
export class InputGroupComponent {
  @Input() control!: AbstractControl;
  @Input() error = '';
  @Input() type = 'text';
  @Input() title = '';
  @Input() id!: string;
  @Input() placeholder = '';
  @Input() rows?: number = 3;
}
